import { useEffect } from 'react';

import { TIMEOUT_MINUTES } from '../const';

export const useSetTimeoutInMinutes = (
  callback: () => void,
  minutes: number = TIMEOUT_MINUTES,
) => {
  useEffect(() => {
    const timeout = minutes * 60 * 1000;
    const timeoutId = setTimeout(callback, timeout);
    return () => clearTimeout(timeoutId);
  }, [callback, minutes]);
};
